import React from 'react';
import { css } from 'aphrodite';
import { NavLink } from 'react-router-dom';
import styles from './reset-password-styles';
import { FilledGreenButton } from '../common';
import { FaEnvelope, FaCheckCircle } from 'react-icons/fa';


const ResetConfirmView = (props) => (
  <div className={css(styles.root)}>
    <img src={require('../../assets/kiffgo/logo-green.svg')} className={css(styles.logo)} />
    {!props.passwordResetSuccessfully && <React.Fragment>
      <h1 className={css(styles.title)}>
        New Password
    </h1>
      <div className={css(styles.description)}>
        Welcome back! <br /> Please enter your new password
    </div>

      <div className={css(styles.content)}>
        <div style={{ position: 'relative' }}>
          <div className={css(styles.inputIconContainer)}><FaEnvelope className={css(styles.inputIcon)} /></div>
          <input placeholder={'Password'} type={'password'} className={css(styles.input)} value={props.password}
            onKeyDown={props.handleKeyDown}
            onChange={props.onChangePassword} />
        </div>

        <div style={{ position: 'relative' }}>
          <div className={css(styles.inputIconContainer)}><FaEnvelope className={css(styles.inputIcon)} /></div>
          <input placeholder={'Confirm Password'} type={'password'} className={css(styles.input)} value={props.confirmPassword}
            onKeyDown={props.handleKeyDown}
            onChange={props.onChangeConfirmPassword} />
        </div>

        <FilledGreenButton disabled={props.disabled} title={'Save Password'} onClick={props.resetConfirm} loading={props.loading} />

      </div>
    </React.Fragment>}



    {props.passwordResetSuccessfully &&

      <React.Fragment>
        <div className={css(styles.content)}>

          <div className={css(styles.tickWrapper)}>
            <FaCheckCircle className={css(styles.tickIcon)} />
          </div>
          <h4 className={css(styles.innerTitle)}>
            Password successfully updated.
      </h4>
          <div className={css(styles.description)}>
            Please get logged in with new password.
      </div>

        </div>

        <NavLink to={'/'} className={css(styles.forgottenPasswordLink)}>
          Login
        </NavLink>

      </React.Fragment>
    }


  </div >
);

export default ResetConfirmView;



// WEBPACK FOOTER //
// ./src/components/reset-password/reset-confirm-view.js